import { useNetworkRequest } from '@/lib/utils/request'

import { TaskProgress } from '../types/taskProgress'

// Pass `null` until the caller wants the data (e.g. a popout has been opened) — SWR skips
// the request entirely while the key is `null`, so this stays lazy by default.
export const useTaskProgress = (taskId: string | null) =>
  useNetworkRequest<TaskProgress>(taskId ? { url: `/v1/tasks/${taskId}/progress/` } : null)
